$(function() {
  var $formSelect = $('select.form-select').select2({
    minimumResultsForSearch: 10
  });
  $('select.form-select').on('change', function() {
    $(this).parent('div').find('.onfocus').addClass('onvalue');
  });
});